import axios from 'axios'
// import router from '../router/index'
const http = axios.create({
  //   baseURL: process.env.NODE_ENV === 'production' ? 'https://ty.hzcu.edu.cn/app/' : '',
  //   baseURL: process.env.NODE_ENV === 'production' ? 'http://10.66.22.52:80/app/' : '',
  //   baseURL: 'http://10.66.22.119:80/',
  //   baseURL: 'http://10.66.22.48/app',
  //   baseURL: 'http://10.66.22.123:8080/app',
  //   baseURL: 'http://j.ngrok.hzwolf.com:801',
  //   baseURL: 'http://10.66.22.52:80/app',
  //   baseURL: 'http://10.66.22.106:92',
  baseURL: 'https://ty.hzcu.edu.cn/app',
  //   baseURL: 'https://lsxyty.hzwolf.com/app',
  //   baseURL: 'https://xxty.lsu.edu.cn/app',
  //   baseURL: 'http://10.66.27.186:60',
  //   baseURL: 'https://ty.hzwolf.com/app',
  //   baseURL: 'http://tygl.hzwolf.com',
  //   baseURL: 'https://ty.zime.edu.cn/app',
  //   baseURL:'http://127.0.0.1:92',
  withCredentials: true,
})
http.interceptors.request.use(
  (config) => {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (res) => {
    console.log('response res:', res)
    if (res.data.statusCode == -3) {
      //   console.log('在这儿重定向')
      //   window.open(res.data.obj, 'myLogin')
      window.location.href = res.data.obj
      //   router.push(res.data.obj)
    }
    // if (res.data.statusCode == 0) {
    //     router.push('/login')
    // }
    // if (res.data.statusCode == -2) {
    //     router.push('/finished')
    // }
    return res
  },
  (err) => {
    // if (err.response.data.message) {
    //   Vue.prototype.$message({
    //     type: 'error',
    //     message: err.response.data.message,
    //   })
    //   if (err.response.status === 401) {
    //     router.push('/login')
    //   }
    // }

    return Promise.reject(err)
  }
)

export default http
export function post(url, params) {
  return new Promise((resolve, reject) => {
    http
      .post(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export function get(url) {
  return new Promise((resolve, reject) => {
    http
      .get(url)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// function getCookie(name) {
//   let cookieArr = document.cookie.split(';')
//   console.log('cookieArr:', cookieArr)
//   for (let i = 0; i < cookieArr.length; i++) {
//     let cookiePair = cookieArr[i].split('=')
//     if (name == cookiePair[0].trim()) {
//       return decodeURIComponent(cookiePair[1])
//     }
//   }
//   return null
// }
